import angular from "angular"
import { openGemaparkBookingUrl } from "../shared/utils"

// Is this file needed? Should probably remove

export class PitchAvailabilityComponent {
  /*@ngInject*/
  constructor($sce, $stateParams) {
    this.$sce = $sce
    this.$stateParams = $stateParams
  }

  getPhysicalUnitIdAtt() {
    if (this.physicalUnitIds.length === 1) {
      return `&puid=${this.physicalUnitIds[0]}`
    }
    return ""
  }

  getUnitId() {
    if (this.unitId) {
      return this.unitId
    }

    if (this.unitIdsForPhysicalUnitIds) {
      return this.unitIdsForPhysicalUnitIds[this.physicalUnitIds[0]]
    }
    return ""
  }

  $onInit() {
    const bookingDetails = {
      accomTypeId: this.accomTypeId,
      campsiteName: this.campsiteinfo.name,
      endDate: this.endDate,
      gemaparkCompanyId: this.campsiteinfo.gemaparkcid,
      gemaparkParkId: this.campsiteinfo.gemaparkparkid,
      numOfAdults: this.numOfAdults,
      numOfChildren: this.numOfChildren,
      numOfInfants: this.numOfInfants,
      physicalUnitIdAtt: this.getPhysicalUnitIdAtt(),
      startDate: this.startDate,
    }
    openGemaparkBookingUrl(bookingDetails, this.getUnitId())
    this.onClose()
  }
}

export default angular.module("directives.pitchavailability", []).component("pitchavailability", {
  controller: PitchAvailabilityComponent,
  bindings: {
    accomTypeId: "<",
    campsiteinfo: "<",
    onClose: "&",
    startDate: "<",
    numOfAdults: "<",
    numOfChildren: "<",
    numOfInfants: "<",
    endDate: "<",
    pitchArea: "<",
    pitchName: "<",
    pitchSurf: "<",
    physicalUnitIds: "<",
    unitId: "<",
    unitIdsForPhysicalUnitIds: "<",
  },
}).name
